// biome-ignore lint/style/noRestrictedImports: legacy import, will be migrated
import styled, { css } from 'styled-components';

export const FilterWrapper = styled.div`
  width: min-content;
  height: min-content;
  position: relative;
  display: flex;
  justify-content: end;
`;

export const OptionsWrapper = styled.div<{
  isDark: boolean;
  isRight?: boolean;
}>(
  ({ theme, isDark, isRight }) => css`
    width: 200px;
    max-height: 240px;
    position: absolute;
    top: 100%;
    margin-top: 15px;
    border-radius: 5px;
    overflow: auto;
    box-shadow: ${isDark ? 'none' : theme.boxShadow['1-dp']};
    background-color: ${
      isDark ? theme.colors.gray['main-dark-mode'] : theme.colors.white
    };

    ${
      isRight
        ? css`
          left: 0;
        `
        : css`
          right: 0;
        `
    }
  `,
);

export const Option = styled.div<{
  isDark: boolean;
  isRounded?: boolean;
  isSelectable?: boolean;
}>(
  ({ theme, isDark, isRounded, isSelectable }) => css`
    width: 100%;
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: ${isSelectable ? 'start' : 'space-between'};
    padding: 0 24px;
    border-bottom-left-radius: ${isRounded ? '5px' : '0'};
    border-bottom-right-radius: ${isRounded ? '5px' : '0'};
    cursor: pointer;

    :hover {
      background-color: ${
        isDark
          ? theme.colors.base['light-dark-mode']
          : theme.colors.gray.lighter
      };
    }
  `,
);

export const InverseButton = styled.button<{
  isDark?: boolean;
  isActive?: boolean;
}>(
  ({ theme, isDark, isActive }) => css`
    border-width: 1px;
    border-style: solid;
    border-radius: 5px;
    transition: background-color 150ms ease-in-out, color 150ms ease-in-out,
      border 150ms ease-in-out;
    height: 40px;
    padding: 0 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    white-space: nowrap;
    border-color: ${
      isDark ? theme.colors.gray['lighter-dark-mode'] : theme.colors.gray.main
    };
    color: ${
      isDark ? theme.colors.white : theme.colors.gray['lighter-dark-mode']
    };
    background-color: ${
      isDark ? theme.colors.base['light-dark-mode'] : theme.colors.white
    };

    ${
      isActive &&
      css`
      border-color: ${
        isDark ? theme.colors.secondary.light : theme.colors.primary.light
      };
      color: ${
        isDark ? theme.colors.secondary.main : theme.colors.primary.main
      };
    `
    }

    :hover {
      background-color: ${
        isDark ? theme.colors.gray['main-dark-mode'] : theme.colors.gray.lighter
      };
    }

    :active {
      border-color: ${theme.colors.base.lighter};
      color: ${theme.colors.white};
      background-color: ${theme.colors.base.lighter};
    }
  `,
);
